import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["program", "progressRequirement", "schedulingRestriction"]

    connect() {
    }

    selectProgram() {
        const program = this.programTarget;
        const number_of_sessions = parseInt(program.selectedOptions[0].dataset.sessions);

        if (number_of_sessions > 0) {
            this.progressRequirementTarget.disabled = false;
            this.schedulingRestrictionTarget.disabled = false;

            this.populateSessions(number_of_sessions);
        } else {
            //TODO hmmm....
        }
    }

    populateSessions(number_of_sessions) {
        const select = this.progressRequirementTarget;

        select.innerHTML = "";
        select.add(new Option("Select a Session", ""));
        for (let i = 1; i <= number_of_sessions; i++) {
            select.add(new Option(`Session #${i}`, i))
        };

        select.disabled = false;
    }
};
